import type { SpriteFrames } from '../types/SpriteFrames.js';

/**
 * Jubit — the Cosmic Navigator.
 * Placeholder sprite for Phase 1 scaffold; final art to be imported from
 * `jubit-ai-universe/src/lib/mascotData.ts` during Phase 2.
 */
export const jubitSprite: SpriteFrames = {
  idle: [
    '   ╭─────╮   ',
    '   │ ○ ○ │   ',
    '   │  ▽  │   ',
    '   ╰─────╯   ',
    '     ✦ ✦     ',
  ],
  blink: [
    '   ╭─────╮   ',
    '   │ ─ ─ │   ',
    '   │  ▽  │   ',
    '   ╰─────╯   ',
    '     ✦ ✦     ',
  ],
};
